<template>
  <div class="box box--quiz2">
    <div class="box-icon">
      <div class="box-icon-bg" :style="{background: company.colorPrimary}" />
      <img :src="icon">
    </div>
    <router-link :to="`leaderboard/${box.idQuiz}`" class="box-title"><span>{{box.name}}</span></router-link>
    <div class="box-bottom2"><a>View leaders</a></div>
  </div>
</template>

<script>
export default {
props: ["box"],
name: "LeaderboardBox",
computed: {
  company() {
    return this.$store.getters.company
  },
  icon() {
    return '/web/quiz_leaderboard_icon.svg'
  }
}
}
</script>

<style scoped>

</style>